import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

// lazy import 방식
const routes = [
  {
    // 로그인
    path: '/',
    name: 'LoginPage',
    component: () =>
      import(
        /* webpackChunkName: "views-login" */
        '@/views/authentication/Login'
      ),
  },
  {
    // 로그인 시 기본 형태
    path: '/home',
    component: () =>
      import(
        /* webpackChunkName: "layouts-default-index" */
        '@/layouts/default/Index'
      ),
      
    // 형태를 따라야 할 세부 페이지는 모두 child 컴포넌트로 넣어주세요
    children: [
      {
        path: '/',
        name: 'HomePage',
        component: () =>
          import(
            /* webpackChunkName: "views-home" */
            '@/views/Home'
          ),
      },
      {
        path: '/account-management',
        name: 'AccountManagement',
        component: () =>
          import(
            /* webpackChunkName: "views-account-management" */
            '@/views/AccountManagement'
          ),
      },
      {
        path: '/market-management',
        name: 'MarketManagement',
        component: () =>
          import(
            /* webpackChunkName: "views-market-management" */
            '@/views/MarketManagement'
          ),
      },
      {
        path: '/ven-management',
        name: 'VenManagement',
        component: () =>
          import(
            /* webpackChunkName: "views-ven-management" */
            '@/views/VenManagement'
          ),
      },
      {
        path: '/menu/ven-sales',
        name: 'VenSales',
        component: () =>
          import(
            /* webpackChunkName: "views-menu-ven-sales" */
            '@/views/Menu/VenSales'
          ),
      },
      {
        path: '/menu/sales',
        name: 'Sales_',
        component: () =>
          import(
            /* webpackChunkName: "views-menu-sales" */
            '@/views/Menu/Sales_'
          ),
      },
    ],
  },
  // 정의되지 않은 모든 path 접근 시
  {
    path: '*',
    component: () => import('@/views/NotFound'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
